import { Button } from '@@/buttons';

import { VulnerabilityRow } from '../types';

import { columnHelper } from './helper';

/**
 * Opens the findings for this workload rather than linking to the application.
 * trivy-operator reports against the owning ReplicaSet or Pod, whose names the
 * application route cannot resolve.
 */
export function buildNameColumn(
  onViewDetails: (row: VulnerabilityRow) => void
) {
  return columnHelper.accessor('name', {
    header: 'Workload',
    id: 'name',
    cell: ({ row: { original: row } }) => (
      <div>
        <Button
          color="link"
          onClick={() => onViewDetails(row)}
          data-cy={`vulnerability-details-${row.id}`}
          className="!m-0 !p-0"
        >
          {row.workload}
        </Button>
        <div className="text-muted text-xs">
          {row.namespace}
          {row.resourceKind && ` · ${row.resourceKind}`}
        </div>
      </div>
    ),
  });
}
